<template>
    <b-modal
              id="modal-email"
              ref="email-modal"
              size="lg"
              hide-footer
              title="Using Component Methods"
            >
              <template #modal-header="{ close }">
                <button class="btn btn-modal-close" @click="close()">
                  <span class="material-icons"> close </span>
                </button>
                <!-- Emulate built in modal header close button action -->
                <div class="container">
                  <div class="row">
                    <div class="col-12 d-flex align-items-center">
                      <p class="h4 d-inline heading-text">
                        Autenticação de dois fatores
                      </p>
                    </div>
                    <div class="col">
                      <p class="description-modal" style="font-size:13px;">
                        Um email com o seu código de segurança foi enviado, por favor verifique sua caixa de entrada ou spam.
                      </p>
                    </div>
                  </div>
                </div>
              </template>
  <div class="two-factor-image">
            <div class="form-group two-factor" v-if="!VerifiedCode">
            <label for="startCode">
              <template v-if="registeredCode">
                <p style="font-size: 13px;color: #707070;">Digite o código enviado para seu e-mail:</p>
              </template>
            </label>
            <div class="two-factor d-flex justify-content-between gap-3 mb-2">
              <div class="part">
                <input
                  id="startCode"
                  type="text"
                  maxlength="1"
                  v-model="code[0]"
                  placeholder=" "
                  autocomplete="off"
                  ref="firstCodeChar"
                  @paste="inputFromClipboard"
                  @keyup="(e) => nextInput(0, e)"
                  @focus="(e) => e.target.select()" />
              </div>
              <div class="part" v-for="(_, index) in new Array(5)" :key="index">
                <input
                  type="text"
                  maxlength="1"
                  placeholder=" "
                  autocomplete="off"
                  ref="codeChars"
                  v-model="code[index + 1]"
                  @keyup="(e) => nextInput(index + 1, e)"
                  @focus="(e) => e.target.select()" />
              </div>
            </div>
            <template>
              <button
                type="button"
                class="btn btn-yup-purple btn-block"
                :class="{ 'qt-loader qt-loader-mini qt-loader-right': isSending }"
                :disabled="isSending"
                @click="checkCode()">
                Verificar
              </button>
            </template>
            <p class="description-modal mt-3">Não recebeu o email? <a href="javascript:void(0)" @click="sendEmail()">Reenviar</a></p>
          </div>
        </div>
        </b-modal>
  </template>

<script>
import axios from '@/plugins/axios';
import LoadingAnim from '@/components/rebranding/animLottie/Loading.vue';

export default {
  name: 'QrcodeTfaConfig',
  components: {
    // LoadingAnim,
  },
  data() {
    return {
      isSending: false,
      imageCode: null,
      registeredCode: false,
      RequestingCode: true,
      VerifiedCode: false,
      code: ['', '', '', '', '', ''],
    };
  },
  created() {
    // this.getQrCode();
  },
  methods: {
    sendEmail() {
      axios().post('2fa/send-email').then((response) => {
        this.$toast.show({
          title: 'Email enviado',
          content: response.data.message,
          type: 'success',
        });
      }).catch((error) => {
        this.$toast.show({
          title: 'Erro',
          content: error.response.data.error,
          type: 'danger',
        });
      });
    },
    inputFromClipboard(event) {
      event.preventDefault();

      const source = event.clipboardData.getData('text/plain');

      if (source) {
        this.code = source.substring(0, 6).replace(/\D+/g, '').split('');
      }
    },
    nextInput(current, event) {
      const key = event.key;

      if (key === 'Backspace') {
        current -= 1;
      } else if (key >= 0 && key <= 9) {
        current += 1;
      } else if (key === 'Enter' && current === 5) {
        this.checkCode();
        return;
      } else {
        return;
      }

      if (current === -1) return;

      let next;

      if (current === 0) {
        next = this.$refs?.firstCodeChar;
      } else {
        next = this.$refs.codeChars?.[current - 1];
      }

      if (next) {
        next.focus();
        next.select();
      }
    },
    checkCode() {
      if (this.isSending) return;

      const otp = this.code.join('');
      const url = '2fa/verify-email';

      if (otp.length !== 6) {
        this.$toast.show({
          title: 'Erro',
          content: 'Código inválido',
          type: 'danger',
        });
        return;
      }

      this.isSending = true;

      axios().post(url, { otp }).then((response) => {
        localStorage.setItem('yup_chat_tfa', JSON.stringify(this.$store.state?.auth?.token));

        if (response.data?.success) {
          this.$toast.show({
            title: 'Sucesso',
            content: 'Código verificado com sucesso!',
            type: 'success',
          });
          this.$emit('verified');
          setTimeout(() => {
            this.isSending = false;
            this.VerifiedCode = true;
          }, 500);
        } else {
          this.$toast.show({
            title: 'Erro',
            content: 'Erro na configuração do TFA',
            type: 'danger',
          });
        }
      }).catch((error) => {
        this.isSending = false;

        const status = error?.response?.status;

        if (status === 403) {
          error = 'Código invalido';
        } else if (status) {
          error = error.response.data;
        } else {
          error = `${error}`;
        }

        this.$toast.show({
          title: 'Erro',
          content: error,
          type: 'danger',
        });
      });
    },
    showModal() {
      this.$refs['email-modal'].show();
    },
    hideModal() {
      this.$refs['email-modal'].hide();
    },
    toggleModal() {
    // We pass the ID of the button that we want to return focus to
    // when the modal has hidden
      this.sendEmail();
      this.$refs['email-modal'].toggle('#toggle-qrcode-btn');
    },
  },
};
</script>

  <style lang="scss" scoped>

  .step-circle {
      background: #752DE6;
      border-radius: 100%;
      color: white;
      padding: 0.5em 0.8em 0.5em 0.9em;
      margin: 1em;
  }
  .two-factor-loader, .two-factor-image {
    max-width: 100%;
  }

  .two-factor-image {
    padding: 1rem;
  }

  .two-factor{
    max-width: 410px;
    margin: 0 auto;
  }

  .btn-store {
    margin-bottom: .4rem;
    border-radius: .32rem;
    background-color: #000;
    height: 52px;
    width: 100%;
    font-size: 1rem;
    font-weight: bold;
    font-family: "Lucida Grande", sans-serif;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    & > * {
      pointer-events: none;
    }

    & > div > svg {
      width: 28px;
    }

    .text {
      text-align: left;

      span {
        display: block;
        font-size: 65%;
        font-weight: normal;
      }
    }
  }

  .two-factor {
    .btn-sms {
      border: thin solid #ccc;
      padding: 4px 14px;
      font-size: .72rem;
      border-radius: 20px;
      height: auto !important;
    }

    .to-app {
      background-color: transparent;
      padding-right: 0;
      padding-left: 0;
      color: var(--clr-yup-purple);
    }

    .part {
      width: 14%;

      & > input {
        border-radius: .3rem;
        border: thin solid #ccc;
        outline: 0 solid #752DE6;
        width: 100%;
        padding: .62rem 0;
        transition: .2s all ease;
        text-align: center;

        &:not(:placeholder-shown) {
          border-color: transparent;
          outline-width: .14rem;
        }
      }
    }
  }

  .two-factor-loader {
    .qt-loader {
      width: 100%;
      height: 150px;

      &::before {
        border-color: #000;
        border-left-color: transparent;
        border-bottom-color: transparent;
        left: 50% !important;
        top: 50% !important;
        margin: 0 !important;
        transform: translate(-50%, -50%);
      }
    }
  }

  .two-factor-image {
    text-align: center;
  }

  h1 {
    font-weight: bold;
    margin-bottom: 30px;
    text-align: center;
  }

  .eye_icon {
    color: #bfc5cb;
  }

  .btn {
    margin: 0.5em 0;
  }

  .register {
    border-color: #0e1421 !important;
    color: #0e1421;
  }

  .checkbox {
    font-weight: 400;
    font-size: 14px;
    color: #752de6;
    margin-bottom: 10px;
  }

  .form-group {
    label {
      color: var(--foreground);
      font-size: 16px;
      margin-bottom: 20px;
    }
    input:-ms-input-placeholder {
      text-transform: lowercase !important;
    }
    input::-webkit-input-placeholder {
      text-transform: lowercase !important;
    }
    input::placeholder {
      text-transform: lowercase !important;
    }

    #inputPassword {
      border-right-color: transparent;
      border-right-width: 0;
    }

    .eyes_btn {
      background-color: var(--form-input);
      border: 1px solid var(--form-border);
      border-left-color: transparent;
      border-radius: 0.25rem;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
  .darkmode .rebranding .form-control {
    border-right-color: transparent !important;
  }
  .darkmode .form-group .eyes_btn {
    background-color: var(--form-input);
    border-color: var(--form-border);
    border-left-color: transparent;
  }
  #toggle-import-btn {
    display: flex;
    align-items: center;
  }
  .btn-wrapper {
    gap: 2rem;
    @media (max-width: 767.98px) {
      flex-wrap: wrap;
      gap: 1rem !important;
    }
  }
  .import-div {
    p:first-of-type {
      color: var(--foreground);
    }
    p:last-of-type {
      color: var(--gray-font-color-4);
    }
  }
  .card-import tr th {
    font-weight: bold;
  }
  .card-import {
    tbody {
      tr {
        border-bottom-color: transparent;
      }
    }
  }
  ::v-deep #modal-email {
    .modal-lg {
      max-width: 645px !important;
    }
    .custom-file-input {
      position: absolute;
      height: 100%;
      top: 0;
      z-index: 1;
      cursor: default;
    }
    .heading-text {
      font-weight: bold;
    }
    .description-modal {
      color: var(--gray-font-color-2);
    }
    .btn-modal-close {
      top: 10px;
      position: absolute;
      right: 0;
      z-index: 5;
      span {
        transition: 0.5s;
      }
      &:hover span,
      &:focus span {
        color: var(--gray-dark) !important;
      }
    }
    .modal-header {
      button {
        .material-icons {
          color: var(--gray-font-color);
        }
      }
    }
    .modal-content {
      padding: 0 !important;
    }
  }
  </style>
